import { Divider } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.7rem;
`;

export const FieldGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 31px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
`;

export const FieldLabel = styled.label`
  font-weight: 600;
  width: 25%;
  text-align: right;
  margin-right: 12px;
`;

export const FieldInputContainer = styled.div`
  width: 40%;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

export const ErrorContainer = styled.div`
  width: 200px;
`;

export const Error = styled.p`
  color: ${COLORS.DARK_RED};
  font-size: 0.875rem;
  margin-left: 0.6rem;
`;

export const SectionDivider = styled(Divider)`
  width: 100%;
  padding-top: 16px;
`;

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 12px 24px;
`;

export const ExternalNameDisplay = styled.div`
  width: 280px;
  min-height: 31px;
  border: 1px solid rgba(0, 0, 0, 0.26);
  border-radius: 4px;
  padding: 6px 10px;
  background-color: rgba(0, 0, 0, 0.04);
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
  font-size: 1rem;
  color: #999999;
  box-sizing: border-box;
  margin-top: 4px;
`;

export const BlankRect = styled.span`
  display: inline-block;
  width: 2rem;
  height: 1rem;
  background-color: #e0e0e0;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 4px;
  margin-right: 4px;
`;
